/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect, useState } from 'react';

import Header from '@edx/frontend-component-header';
import { getConfig } from '@edx/frontend-platform';
import { AppProvider } from '@edx/frontend-platform/react';
import { Helmet } from 'react-helmet';
import {
  Navigate, Route, Routes,
} from 'react-router-dom';

import {
  EmbeddedRegistrationRoute, NotFoundPage, registerIcons, UnAuthOnlyRoute, Zendesk,
} from './common-components';
import configureStore from './data/configureStore';
import {
  AUTHN_PROGRESSIVE_PROFILING,
  LOGIN_PAGE,
  PAGE_NOT_FOUND,
  PASSWORD_RESET_CODE_ENTRY,
  PASSWORD_RESET_CODE_VALIDATOR,
  PASSWORD_RESET_CONFIRM,
  RECOMMENDATIONS,
  REGISTER_EMBEDDED_PAGE,
  REGISTER_PAGE,
  RESET_PAGE,
} from './data/constants';
import { updatePathWithQueryParams } from './data/utils';
import { ForgotPasswordPage } from './forgot-password';
import ForgotPasswordCodePage from './forgot-password-code/ForgotPasswordCodePage';
import Logistration from './logistration/Logistration';
import { ProgressiveProfiling } from './progressive-profiling';
import { RecommendationsPage } from './recommendations';
import { RegistrationPage } from './register';
import { ResetPasswordPage } from './reset-password';

import './index.scss';

registerIcons();

/** Helpers */

function hasCookie(name) {
  if (typeof document === 'undefined') return false; // SSR safety
  return document.cookie.split('; ').some(c => c.startsWith(`${name}=`));
}

const AppRoutes = () => (
  <Routes>
    <Route path="/" element={<Navigate replace to={updatePathWithQueryParams(REGISTER_PAGE)} />} />
    <Route
      path={REGISTER_EMBEDDED_PAGE}
      element={<EmbeddedRegistrationRoute><RegistrationPage /></EmbeddedRegistrationRoute>}
    />
    <Route
      path={LOGIN_PAGE}
      element={
        <UnAuthOnlyRoute><Logistration selectedPage={LOGIN_PAGE} /></UnAuthOnlyRoute>
      }
    />
    <Route path={REGISTER_PAGE} element={<UnAuthOnlyRoute><Logistration /></UnAuthOnlyRoute>} />
    <Route path={RESET_PAGE} element={<UnAuthOnlyRoute><ForgotPasswordPage /></UnAuthOnlyRoute>} />
    <Route
      path={PASSWORD_RESET_CODE_VALIDATOR}
      element={<UnAuthOnlyRoute><ForgotPasswordCodePage /></UnAuthOnlyRoute>}
    />
    <Route
      path={PASSWORD_RESET_CODE_ENTRY}
      element={<UnAuthOnlyRoute><ForgotPasswordCodePage /></UnAuthOnlyRoute>}
    />
    <Route path={PASSWORD_RESET_CONFIRM} element={<ResetPasswordPage />} />
    <Route path={AUTHN_PROGRESSIVE_PROFILING} element={<ProgressiveProfiling />} />
    <Route path={RECOMMENDATIONS} element={<RecommendationsPage />} />
    <Route path={PAGE_NOT_FOUND} element={<NotFoundPage />} />
    <Route path="*" element={<Navigate replace to={PAGE_NOT_FOUND} />} />
  </Routes>
);


const MainApp = () => {

  var now = hasCookie('edx-user-info');
  if(now){
    var isCampusHeader = false;
  }else{
    var isCampusHeader = true;
  }

  return (
    <AppProvider store={configureStore()}>
      <Helmet>
        <link rel="shortcut icon" href={getConfig().FAVICON_URL} type="image/x-icon" />
      </Helmet>
      {getConfig().ZENDESK_KEY && <Zendesk />}
      <main className="is-login-register" id="main">
        <div id="campusil-logistration">
          <Header isCampusHeader={isCampusHeader} />
          <AppRoutes />
        </div>
      </main>
    </AppProvider>
  );

};

export default MainApp;
